'use strict';

var userUnitCtrl = ['$scope',function($scope) {
    this.isAdmin = function(user) {
        if(!user.roles)
            return false;

        var admin = user.roles.filter(function(role) {
            return role.name === 'admin';
        });

        if (admin.length) {
            return true;
        } else {
            return false;
        }
    }

}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        controller: userUnitCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'user-unit-directive/userUnitDirective.html'
    };
};
